import { Headers } from '@egw/components'
import { TabbedWireTransfer } from '@egw/features-transfer'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const WireTransferPage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.transfer.title')} />
      <TabbedWireTransfer />
    </Layout>
  )
}
